import * as React from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
import styled from 'styled-components';
import { Button } from '@helpcenter/analytics-components';
import * as bp from '@helpcenter/styles/src/breakpoints';
import * as grid from '@helpcenter/styles/src/grid';
import { FormattedMessage } from 'react-intl-next';
import LikeIcon from '@atlaskit/icon/core/thumbs-up';
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import i18n from './messages';

export interface Props {
    onClickYes: () => void;
    onClickNo: () => void;
    initialScreen?: State['screen'];
}

interface State {
    screen: 'ask-for-feedback' | 'helpful' | 'unhelpful';
}

export default class FeedbackCollector extends React.Component<Props, State> {
    state: State = {
        screen: this.props.initialScreen || 'ask-for-feedback',
    };

    onClickYes = () => {
        this.props.onClickYes();
        this.setState({ screen: 'helpful' });
    };

    onClickNo = () => {
        this.props.onClickNo();
        this.setState({ screen: 'unhelpful' });
    };

    renderFeedBackView = (): React.ReactNode => {
        return (
            <React.Fragment>
                <FormattedMessage {...i18n.prompt} />
                <Box xcss={ButtonStyles}>
                    <Button
                        actionSubjectId="feedbackCollectorHelpfulButton"
                        appearance="subtle"
                        iconBefore={
                            <ThumbsUp>
                                <LikeIcon spacing="spacious" label="" />
                            </ThumbsUp>
                        }
                        onClick={this.onClickYes}
                    >
                        <FormattedMessage {...i18n.yes} />
                    </Button>
                </Box>

                <Box xcss={ButtonStyles}>
                    <Button
                        actionSubjectId="feedbackCollectorUnhelpfulButton"
                        appearance="subtle"
                        iconBefore={
                            <ThumbsDown>
                                <LikeIcon spacing="spacious" label="" />
                            </ThumbsDown>
                        }
                        onClick={this.onClickNo}
                    >
                        <FormattedMessage {...i18n.no} />
                    </Button>
                </Box>
            </React.Fragment>
        );
    };

    render() {
        const { screen } = this.state;

        let content;

        switch (screen) {
            case 'unhelpful':
                content = <FormattedMessage {...i18n.unHelpfulResponse} />;
                break;

            case 'helpful':
                content = <FormattedMessage {...i18n.helpfulResponse} />;
                break;

            case 'ask-for-feedback':
            default:
                content = this.renderFeedBackView();
                break;
        }

        return <Root>{content}</Root>;
    }
}

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const Root = styled.div`
    display: flex;
    align-items: center;
    font-weight: 600;
    height: ${grid.multiple(8).px};

    ${bp.fromMedium.css`
        align-items: center;
    `};

    > * {
        padding: 0;
    }
`;

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const ThumbsUp = styled.div`
    margin-top: 0;
`;

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const ThumbsDown = styled.div`
    /* we flip the AtlasKit thumbs up icon vertically to get the desired thumbs down icon */
    transform: rotateX(180deg);
    margin-top: ${token('space.050', '4px')};
`;

const ButtonStyles = xcss({
    marginLeft: 'space.200',
});
